<template>
  <div>
    <head>
      <link rel="shortcut icon" href="assets/images/favicon.svg">
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
      <div id="layout-wrapper">
        <NavigationBar />

        <div id="content" class="content-minimize">
          <div class="page-content">
            <div class="container-fluid">

              <!-- Page Title -->
              <div class="row">
                <div class="col-12">
                  <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 class="mb-sm-0 font-size-18">Stock Movements</h4>
                    <div class="page-title-right">
                      <ol class="breadcrumb m-0">
                        <li class="breadcrumb-item"><a href="javascript:void(0);" @click="goTo('hospital-dashboard')">Hospital</a></li>
                        <li class="breadcrumb-item"><a href="javascript:void(0);" @click="goTo('pharmacy-inventory')">Inventory</a></li>
                        <li class="breadcrumb-item active">Stock Movements</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Stats Cards -->
              <div class="row">
                <div class="col-xl-3 col-md-6">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium mb-2">Total Movements</p>
                          <h4 class="mb-0">{{ stats.total || 0 }}</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                            <span class="avatar-title"><i class="mdi mdi-swap-horizontal font-size-24"></i></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-3 col-md-6">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium mb-2">Stock In</p>
                          <h4 class="mb-0 text-success">{{ stats.stockIn || 0 }}</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                            <span class="avatar-title bg-success"><i class="mdi mdi-arrow-down font-size-24"></i></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-3 col-md-6">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium mb-2">Stock Out</p>
                          <h4 class="mb-0 text-danger">{{ stats.stockOut || 0 }}</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-danger">
                            <span class="avatar-title bg-danger"><i class="mdi mdi-arrow-up font-size-24"></i></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-3 col-md-6">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium mb-2">Adjustments</p>
                          <h4 class="mb-0 text-warning">{{ stats.adjustments || 0 }}</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                            <span class="avatar-title bg-warning"><i class="mdi mdi-plus-minus font-size-24"></i></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Main Card -->
              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <!-- Header Actions -->
                      <div class="d-flex justify-content-between align-items-center mb-4">
                        <div>
                          <h5 class="mb-1"><i class="mdi mdi-history me-2 text-primary"></i>Movement History</h5>
                          <small class="text-muted">Track all stock movements</small>
                        </div>
                        <div class="d-flex gap-2">
                          <button class="btn btn-outline-primary" @click="exportMovements">
                            <i class="mdi mdi-download me-1"></i> Export
                          </button>
                          <button class="btn btn-outline-secondary" @click="goTo('pharmacy-inventory')">
                            <i class="mdi mdi-package-variant me-1"></i> Inventory
                          </button>
                        </div>
                      </div>

                      <!-- Filters -->
                      <div class="row mb-3">
                        <div class="col-md-3">
                          <label class="form-label small">From Date</label>
                          <input type="date" class="form-control" v-model="filters.dateFrom" @change="loadMovements">
                        </div>
                        <div class="col-md-3">
                          <label class="form-label small">To Date</label>
                          <input type="date" class="form-control" v-model="filters.dateTo" @change="loadMovements">
                        </div>
                        <div class="col-md-3">
                          <label class="form-label small">Movement Type</label>
                          <select class="form-select" v-model="filters.movementType" @change="loadMovements">
                            <option value="">All Types</option>
                            <option value="IN">Stock In</option>
                            <option value="OUT">Stock Out</option>
                            <option value="ADJUSTMENT">Adjustment</option>
                            <option value="DISPOSAL">Disposal</option>
                            <option value="TRANSFER">Transfer</option>
                          </select>
                        </div>
                        <div class="col-md-3">
                          <label class="form-label small">Search</label>
                          <div class="input-group">
                            <input type="text" class="form-control" v-model="filters.search" @input="debounceSearch" placeholder="Drug name, batch...">
                            <button class="btn btn-light" @click="loadMovements"><i class="mdi mdi-magnify"></i></button>
                          </div>
                        </div>
                      </div>

                      <!-- Quick Date Filters -->
                      <div class="mb-3">
                        <div class="btn-group btn-group-sm">
                          <button class="btn" :class="dateRange === 'today' ? 'btn-primary' : 'btn-outline-secondary'" @click="setDateRange('today')">Today</button>
                          <button class="btn" :class="dateRange === 'week' ? 'btn-primary' : 'btn-outline-secondary'" @click="setDateRange('week')">This Week</button>
                          <button class="btn" :class="dateRange === 'month' ? 'btn-primary' : 'btn-outline-secondary'" @click="setDateRange('month')">This Month</button>
                          <button class="btn" :class="dateRange === 'all' ? 'btn-primary' : 'btn-outline-secondary'" @click="setDateRange('all')">All Time</button>
                        </div>
                      </div>

                      <!-- Loading -->
                      <div v-if="loading" class="text-center py-5">
                        <div class="spinner-border text-primary"></div>
                        <p class="text-muted mt-2 mb-0">Loading movements...</p>
                      </div>

                      <!-- Movements Table -->
                      <div v-else class="table-responsive">
                        <table class="table table-hover align-middle">
                          <thead class="table-light">
                            <tr>
                              <th>Date/Time</th>
                              <th>Drug</th>
                              <th>Batch</th>
                              <th class="text-center">Type</th>
                              <th class="text-end">Quantity</th>
                              <th>Reference</th>
                              <th>By</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="movement in movements" :key="movement.movementID">
                              <td>
                                <div>{{ formatDate(movement.dateCreated) }}</div>
                                <small class="text-muted">{{ formatTime(movement.dateCreated) }}</small>
                              </td>
                              <td>
                                <div class="fw-medium">{{ movement.drugName || movement.genericName }}</div>
                                <small class="text-muted">{{ movement.genericName }}</small>
                              </td>
                              <td><code>{{ movement.batchNo }}</code></td>
                              <td class="text-center">
                                <span class="badge" :class="getMovementBadge(movement.movementType)">
                                  <i class="mdi me-1" :class="getMovementIcon(movement.movementType)"></i>
                                  {{ formatMovementType(movement.movementType) }}
                                </span>
                              </td>
                              <td class="text-end">
                                <span :class="movement.movementType === 'IN' ? 'text-success' : 'text-danger'">
                                  {{ movement.movementType === 'IN' ? '+' : '-' }}{{ movement.quantity }}
                                </span>
                              </td>
                              <td>
                                <span v-if="movement.referenceNo">{{ movement.referenceNo }}</span>
                                <small class="text-muted d-block">{{ movement.referenceType }}</small>
                              </td>
                              <td>{{ movement.createdBy }}</td>
                            </tr>
                            <tr v-if="movements.length === 0">
                              <td colspan="7" class="text-center py-4 text-muted">
                                <i class="mdi mdi-swap-horizontal-circle-outline font-size-24 d-block mb-2"></i>
                                No movements found
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <!-- Pagination -->
                      <div v-if="totalPages > 1" class="d-flex justify-content-between align-items-center mt-3">
                        <small class="text-muted">
                          Showing {{ ((currentPage - 1) * pageSize) + 1 }} - {{ Math.min(currentPage * pageSize, totalCount) }} of {{ totalCount }}
                        </small>
                        <nav>
                          <ul class="pagination pagination-sm mb-0">
                            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                              <a class="page-link" href="javascript:void(0);" @click="goToPage(currentPage - 1)">Prev</a>
                            </li>
                            <li v-for="page in visiblePages" :key="page" class="page-item" :class="{ active: page === currentPage }">
                              <a class="page-link" href="javascript:void(0);" @click="goToPage(page)">{{ page }}</a>
                            </li>
                            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                              <a class="page-link" href="javascript:void(0);" @click="goToPage(currentPage + 1)">Next</a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <footer class="footer">
            <div class="container-fluid">
              <div class="row">
                <div class="col-sm-6"></div>
                <div class="col-sm-6">
                  <div class="text-sm-end d-sm-block">County Hospital Management System</div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>

      <!-- Toast Notification -->
      <ToastNotification ref="toast" />
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import ToastNotification from "@/components/hospital/ToastNotification.vue";
import { execute, hospital } from "@/api";

export default {
  name: "StockMovements",
  components: { NavigationBar, ToastNotification },
  data() {
    return {
      loading: false,

      // Movements List
      movements: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 50,

      // Filters
      filters: {
        dateFrom: '',
        dateTo: '',
        movementType: '',
        search: ''
      },
      dateRange: 'month',
      searchTimeout: null,

      // Stats
      stats: {
        total: 0,
        stockIn: 0,
        stockOut: 0,
        adjustments: 0
      },

      // Session
      facilityID: '',
      facilityName: '',
      sessionNames: '',
      sessionIdNo: ''
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.pageSize);
    },
    visiblePages() {
      const pages = [];
      const start = Math.max(1, this.currentPage - 2);
      const end = Math.min(this.totalPages, this.currentPage + 2);
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    }
  },
  methods: {
    goTo(route) {
      this.$router.push('/' + route);
    },

    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    },

    formatTime(date) {
      if (!date) return '';
      return new Date(date).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
    },

    getMovementBadge(type) {
      const badges = {
        'IN': 'bg-success',
        'OUT': 'bg-danger',
        'ADJUSTMENT': 'bg-warning text-dark',
        'DISPOSAL': 'bg-dark',
        'TRANSFER': 'bg-info'
      };
      return badges[type] || 'bg-secondary';
    },

    getMovementIcon(type) {
      const icons = {
        'IN': 'mdi-arrow-down',
        'OUT': 'mdi-arrow-up',
        'ADJUSTMENT': 'mdi-plus-minus',
        'DISPOSAL': 'mdi-delete',
        'TRANSFER': 'mdi-swap-horizontal'
      };
      return icons[type] || 'mdi-circle';
    },

    formatMovementType(type) {
      const labels = {
        'IN': 'Stock In',
        'OUT': 'Stock Out',
        'ADJUSTMENT': 'Adjustment',
        'DISPOSAL': 'Disposal',
        'TRANSFER': 'Transfer'
      };
      return labels[type] || type;
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.loadMovements();
      }, 300);
    },

    goToPage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
      this.loadMovements();
    },

    setDateRange(range) {
      this.dateRange = range;
      const today = new Date();
      
      switch (range) {
        case 'today':
          this.filters.dateFrom = today.toISOString().split('T')[0];
          this.filters.dateTo = today.toISOString().split('T')[0];
          break;
        case 'week':
          const weekStart = new Date(today);
          weekStart.setDate(today.getDate() - today.getDay());
          this.filters.dateFrom = weekStart.toISOString().split('T')[0];
          this.filters.dateTo = today.toISOString().split('T')[0];
          break;
        case 'month':
          const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
          this.filters.dateFrom = monthStart.toISOString().split('T')[0];
          this.filters.dateTo = today.toISOString().split('T')[0];
          break;
        case 'all':
          this.filters.dateFrom = '';
          this.filters.dateTo = '';
          break;
      }
      
      this.loadMovements();
    },

    // Load Movements
    loadMovements() {
      this.loading = true;
      const data = new FormData();
      data.append("function", "getStockMovements");
      data.append("facilityID", this.facilityID);
      data.append("dateFrom", this.filters.dateFrom);
      data.append("dateTo", this.filters.dateTo);
      data.append("movementType", this.filters.movementType);
      data.append("search", this.filters.search);
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);

      execute(data, hospital)
        .then((res) => {
          this.loading = false;
          if (res.data.success) {
            this.movements = res.data.data.movements || [];
            this.totalCount = res.data.data.count?.total || this.movements.length;
            this.calculateStats();
          } else {
            this.movements = [];
          }
        })
        .catch((e) => {
          this.loading = false;
          console.error(e);
        });
    },

    calculateStats() {
      this.stats = {
        total: this.movements.length,
        stockIn: this.movements.filter(m => m.movementType === 'IN').length,
        stockOut: this.movements.filter(m => m.movementType === 'OUT').length,
        adjustments: this.movements.filter(m => m.movementType === 'ADJUSTMENT').length
      };
    },

    // Export Movements
    exportMovements() {
      // Create CSV content
      let csv = 'Date,Time,Drug Name,Batch No,Type,Quantity,Reference,Reference Type,Created By\n';
      
      this.movements.forEach(m => {
        csv += `"${this.formatDate(m.dateCreated)}","${this.formatTime(m.dateCreated)}","${m.drugName || m.genericName}","${m.batchNo}","${this.formatMovementType(m.movementType)}","${m.quantity}","${m.referenceNo || ''}","${m.referenceType || ''}","${m.createdBy}"\n`;
      });

      // Download
      const blob = new Blob([csv], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `stock_movements_${new Date().toISOString().split('T')[0]}.csv`;
      a.click();
      window.URL.revokeObjectURL(url);

      this.$refs.toast.success('Movements exported successfully');
    }
  },
  mounted() {
    this.facilityID = sessionStorage.getItem("hospitalFacilityID") || '';
    this.facilityName = sessionStorage.getItem("hospitalFacilityName") || '';
    this.sessionNames = sessionStorage.getItem("sessionNames") || '';
    this.sessionIdNo = sessionStorage.getItem("sessionIdNo") || '';

    // Set default date range to this month
    this.setDateRange('month');
  }
};
</script>

<style scoped>
.mini-stats-wid .card-body { padding: 20px; }
.mini-stat-icon { width: 48px; height: 48px; }
.avatar-sm { width: 3rem; height: 3rem; }
.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #fff;
}

.table > :not(caption) > * > * { padding: 0.75rem; }
</style>
